import React from 'react';
import { Link } from 'react-router-dom';
import {
  StyledFooterCopyrightContainer,
  StyledFooterHR,
  StyledFooterLogo,
} from './styled';

export const FooterCopyright: React.FC = () => (
  <>
    <StyledFooterHR className="full-width-container" />
    <StyledFooterCopyrightContainer>
      <Link
        aria-label={"Unicredit Leasing"}
        to={{
          pathname: 'https://unicreditleasing.hr/home/',
        }}
        target="_blank">
        <StyledFooterLogo />
      </Link>
    </StyledFooterCopyrightContainer>
  </>
);
